import React from 'react'
import { useAsync } from 'react-async'
import slaRepository from '../SlaRepository'
import solicitacoesRepository from '../../Solicitacoes/SolicitacoesRepository'
import {
  ResponsiveContainer,
  Tooltip,
  BarChart,
  YAxis,
  Bar,
  XAxis,
  CartesianGrid,
  Legend
} from 'recharts'
import { secondsToStringTimer } from '../../../utils/Formatter'
import { Typography, Paper, makeStyles } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2)
  }
}))

const fetchData = async ({ solicitacaoId }) => {
  const [r1, r2] = await Promise.all([
    slaRepository.logSolicitacaoTempoAnalisePorAnalista(solicitacaoId),
    solicitacoesRepository.getOne({ id: solicitacaoId })
  ])
  if (!r1.ok || !r2.ok) throw new Error(r1.error)
  return [r1.data, r2.data]
}

function ChartTempoAnalise(props) {
  const { data } = useAsync({
    promiseFn: fetchData,
    solicitacaoId: props.match.params.id
  })
  const [logs, solicitacao] = data || []
  const classes = useStyles()
  return (
    <Paper className={classes.root}>
      <Typography variant="h6">Tempo em análise por responsável</Typography>
      <ResponsiveContainer height={300}>
        <BarChart
          layout="vertical"
          data={logs}
          margin={{
            top: 20,
            left: 150
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <YAxis dataKey="responsavel" type="category" />
          <Legend iconType="circle" />
          <Tooltip
            formatter={value => {
              return secondsToStringTimer(value, '')
            }}
          />
          <Bar dataKey="Análise" fill="#ffca28" maxBarSize={30} stackId="a" />
          <Bar dataKey="Reanálise" fill="#ffa726" maxBarSize={30} stackId="a" />
          <XAxis
            type="number"
            tickFormatter={tick => {
              return secondsToStringTimer(tick, '')
            }}
          />
        </BarChart>
      </ResponsiveContainer>
      {logs?.length > 1 && !solicitacao?.trocaResponsavel && (
        <Typography variant="caption">
          * Apenas um analista alterou a solicitação
        </Typography>
      )}
    </Paper>
  )
}

export default ChartTempoAnalise
